module.exports = __webpack_public_path__ + "img/superscript.0bba3cea.svg";